<template>
    <v-app>
        <router-view></router-view>
    </v-app>
</template>

<style lang="scss">

    #app {

        font-family: 'SST W01 Roman', Helvetica, Arial, sans-serif; /* this was it */
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;

    }

    .slideSpace {
        padding: 0 22px;
    }

</style>

<script>

    export default {
        name: "App",

    }


</script>
